import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";

import iconMicGray from "../../../assets/images/100-mic-gray.svg";
import noCameraUser from "../../../assets/images/user-with-disabled-camera.svg";
import { useAuth } from "../../../contexts/authContext";
import { useMeetingDetailsStore } from "../../../contexts/meetingDetails/meetingDetailsContext";
import { useUserMedia } from "../../../hooks/useUserMedia";
import { Video } from "../../video-element";

export const UserCamera = observer(({ talking }) => {
  const { previewCamStream } = useUserMedia();
  const { participants } = useMeetingDetailsStore();
  const { userData } = useAuth();

  const [isMuted, setIsMuted] = useState();

  useEffect(() => {
    const currentUser = participants.filter((participant) => participant.user.email === userData.email)[0];
    setIsMuted(currentUser.audio_mute === "muted" || currentUser.audio_mute === null);
  }, [participants, userData.email]);

  const renderThumbVideos = () => {
    if (previewCamStream) {
      return (
        <Video
          autoPlay
          muted
          srcObject={previewCamStream}
          style={{
            objectFit: "cover",
          }}
          width="82"
          height="50.5"
        />
      );
    }
    return <img src={noCameraUser} className="no-cam-icon" width="24" height="24" alt="" />;
  };

  return (
    <div className="meeting-controller-widget-user">
      {isMuted && <img src={iconMicGray} className="mic i i-12" alt="" />}
      {/* <img src={talking ? iconMicGreen : iconMicGray} className="mic i i-12" alt="" /> */}
      {renderThumbVideos()}
      <div className="meeting-controller-widget-label C2-SemiBold"> you</div>
    </div>
  );
});
